import React, { useEffect, useRef } from 'react';
import Pyramid from './components/Pyramid';
import RealityPlanes from './components/RealityPlanes';
import DNAStrand from './components/DNAStrand';
import { useThree } from '@react-three/fiber';
import gsap from 'gsap';

function WireframeScene({ onPlaneClick }) {
  const groupRef = useRef();
  const { scene } = useThree();

  useEffect(() => {
    if (groupRef.current) {
      // Set initial state
      groupRef.current.traverse((object) => {
        if (object.material) {
          object.material.transparent = true;
          object.material.opacity = 0;
        }
      });

      // Stagger the animations for different elements
      const timeline = gsap.timeline({
        defaults: { duration: 1.5, ease: "power2.inOut" }
      });

      // Fade in pyramid
      timeline.to(scene.getObjectByName('pyramid').material, {
        opacity: 0.8,
        duration: 1
      });

      // Fade in DNA strand
      timeline.to(scene.getObjectByName('dna-strand').children, {
        opacity: 0.7,
        stagger: 0.1
      }, "-=0.5");

      // Fade in reality planes
      timeline.to(scene.getObjectByName('reality-planes').children, {
        opacity: 0.15,
        stagger: 0.02
      }, "-=1");
    }
  }, [scene]);

  return (
    <group ref={groupRef}>
      {/* Pyramid */}
      <group name="pyramid">
        <Pyramid />
      </group>

      {/* DNA Strand */}
      <group name="dna-strand" position={[0, 1, 0]}>
        <DNAStrand
          height={125}
          color="#00ff44"
        />
      </group>

      {/* Static reality planes */}
      <group name="reality-planes">
        <RealityPlanes spacing={2.5} numPlanes={50} onPlaneClick={onPlaneClick} />
      </group>
    </group>
  );
}

export default WireframeScene;